








































































import EmailUs from '@/components/EmailUs.vue';
import VideoSection from '@/components/VideoSection.vue';
import { Component, Vue } from 'vue-property-decorator';

@Component({
  components: {
    EmailUs,
    VideoSection,
  },
})
export default class Home extends Vue {
  public email() {
    window.location.href = `mailto:${'rtummocQtcatnoc'.split('').reverse().join('').replace('Q', '@') + '.io'}`;
  }

}
